import * as Yup from "yup";

export const deleteAccountSchema = (t) =>
  Yup.object().shape({
    password: Yup.string().required(
      t("DeleteAccountModal.Password.Error.Required")
    ),
  });
